import { Button, DatePicker, Form, Input, Table } from "antd";
import { SELECTION_ALL, SELECTION_NONE } from "antd/es/table/hooks/useSelection";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../common/api";
import { requiredField } from "../common/common";
const columns = (periods, years) => [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
        fixed: "left",
        width: 70,
    },
    {
        title: "Dipendente",
        sorter: true,
        fixed: "left",
        ellipsis: true,
        key: "name",
        sorter: (a, b) => a.employee.fullName.localeCompare(b.employee.fullName),
        dataIndex: ["employee", "fullName"],
        width: 150,
    },
    {
        title: "Periodo",
        key: "period",
        ellipsis: true,
        dataIndex: "period",
        filters: periods.map((x) => ({
            text: x,
            value: x,
        })),
        filterSearch: true,
        onFilter: (value, record) => record.period === value,
        width: 150,
    },
    {
        title: "Anno",
        key: "year",
        dataIndex: "year",
        ellipsis: true,
        filters: years.map((x) => ({
            text: x,
            value: x,
        })),
        onFilter: (value, record) => record.year === value,
        width: 150,
    },
    {
        title: "Importo netto",
        key: "net",
        dataIndex: "net",
        width: 150,
        align: "right",
        render: (x) =>
            "€ " + x.toLocaleString("it-IT", { minimumFractionDigits: 2, useGrouping: true }),
    },
    {
        title: "TFR",
        key: "tfrType",
        width: 150,
        dataIndex: "tfrType",
        filters: [
            {
                text: "No",
                value: null,
            },
            {
                text: "Anticipo",
                value: "ADVANCE",
            },
            {
                text: "Liquidazione",
                value: "SETTLEMENT",
            },
        ],
        onFilter: (value, record) => record.tfrType === value,
        render: (x) => ({ SETTLEMENT: "Liquidazione", ADVANCE: "Anticipo" })[x] ?? "",
    },
];

export default function () {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate()

    const onFinish = (form) => {
        setLoading(true);
        axiosInstance
            .post("paycheckBatchBankTransfer", {
                ...form,
                paymentDate: form.paymentDate.format("YYYY-MM-DD"),
                paychecks: selectedRowKeys,
            })
            .then(() => navigate(-1))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        axiosInstance
            .get("paycheck", { params: { bankTransfer: false, pageSize: 999999 } })
            .then(({ data }) => setData(data.data));
    }, []);
    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
            <Form id="newBatchTransferForm" layout="vertical" onFinish={onFinish}>
                <Form.Item label="Nome distinta" name={"name"} rules={[requiredField]}>
                    <Input style={{ width: 200 }} />
                </Form.Item>
                <Form.Item label="Data pagamento" name={"paymentDate"} rules={[requiredField]}>
                    <DatePicker format={"DD/MM/YYYY"} />
                </Form.Item>
                <Form.Item label="Causale" name={"paymentReason"} rules={[requiredField]}>
                    <Input style={{ width: 200 }} />
                </Form.Item>
            </Form>
            Selezionate {selectedRowKeys.length} righe
            <Table
                rowKey="id"
                size="small"
                rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                }}
                bordered
                dataSource={data}
                scroll={{ y: 300 }}
                pagination={false}
                virtual
                columns={columns(
                    [...new Set(data.map((x) => x.period))],
                    [...new Set(data.map((x) => x.year))],
                )}
            />
            <Button
                disabled={selectedRowKeys.length === 0}
                style={{ width: 150, placeSelf: "end" }}
                htmlType="submit"
                type="primary"
                form="newBatchTransferForm"
                loading={loading}
            >
                Crea distinta
            </Button>
        </div>
    );
}
